import { createFileRoute, Outlet } from "@tanstack/react-router";

/*
 * Layout-only route — see domains.tsx. `senders.$sourceIp` is a child, so the
 * list must live in senders.index.tsx or it renders in place of the detail.
 */
export const Route = createFileRoute("/portal/senders")({
  component: SendersLayout,
});

function SendersLayout() {
  return <Outlet />;
}
